<template>
  <div>
    <SectionHeadline>
      {{ $t('blog.more_articles') }}
    </SectionHeadline>
    <div class="gap-8" :class="carouselContainerClass">
      <BasicSlider
        v-if="articles && articles.length"
        :max-items-per-slide="4"
        :max-items-per-slide-mobile="2"
        :active="isMobile"
        :items="articles"
      >
        <template #item="{ item }">
          <NuxtLink
            :key="item.uuid"
            :to="toLocalePath('/' + item.full_slug)"
            class="block basis-1/4 px-2 pb-2 text-center font-bold tracking-wide md:px-0"
            @click="
              trackBlogArticle({
                article_title:
                  item.content.teaser_title || item.content.title || '',
                teaser_type: 'small teaser',
                blog_section: 'Weitere Beiträge',
              })
            "
          >
            <CmsImage
              :blok="getTeaserImage(item)"
              class="mb-2"
              aspect-ratio="4/3"
            />
            {{ item.content.teaser_title || item.content.title }}
          </NuxtLink>
        </template>
      </BasicSlider>
    </div>
  </div>
</template>

<script setup lang="ts">
import { uniqBy } from 'es-toolkit'
import type {
  SbBlogArticleV2,
  SbBlogOverviewV2,
  StoryblokStory,
  StoryData,
} from '~/cms/storyblok/types/storyblok.d.ts'

const props = defineProps({
  article: {
    type: Object as PropType<
      StoryblokStory<SbBlogArticleV2> | StoryData<SbBlogArticleV2>
    >,
    default: undefined,
  },
  blogOverview: {
    type: Object as PropType<
      StoryblokStory<SbBlogOverviewV2> | StoryData<SbBlogOverviewV2>
    >,
    default: undefined,
  },
  carouselContainerClass: {
    type: String,
    default: '',
  },
})

const { toLocalePath } = useRouteHelpers()
const article = props.article
const blogOverview = props.blogOverview
const { isMobile } = useDeviceType()
const { trackBlogArticle } = useTrackingEvents()

const articles = computed(() => {
  const list = [
    ...(article?.content?.more_articles || []),
    ...(blogOverview?.content?.more_articles || []),
  ]
  return uniqBy(list, (it) => it.id)
    .slice(0, 4)
    .filter((i) => typeof i !== 'string') as StoryblokStory<SbBlogArticleV2>[]
})
const getTeaserImage = (item: StoryblokStory<SbBlogArticleV2>) =>
  item.content.teaser_image?.[0] || item.content.image?.[0]
</script>
